import React from "react";
import KnowledgeCenter from "./components/KnowledgeCenter/KnowledgeCenter";
import "./App.css";
import Question from "./Question/Question";

const App = () => {
  return (
    <div className="mb-5">
      <KnowledgeCenter></KnowledgeCenter>
      <div>
        <Question></Question>
      </div>
    </div>
  );
};

export default App;
